import React from "react";
import { Col, Form, InputGroup, Row } from "react-bootstrap";
import TableInvoices from "../../orders/orderPayments/tableInvoices";
import TablePaymentsVaroExpress from "./tablePaymentsVaroExpress";
import DatatableStampedInvoices from "./invoice/datatableStampedInvoices";
import { useState } from "react";

const AccordionPayments = ({
  values,
  formatNumberWithCommas,
  setPaymentTypes,
  paymentTypes,
  isAccountant,
  isAdmin,
  refreshKey,
  disabled
}) => {
  const razonSocialFacturacion = "VaroExpress";

  const isDisabled = () => false;
  //const isDisabled = () => !(isAccountant() || isAdmin());
  const [totalFacturadoSW, setTotalFacturadoSW] = useState(0);

  // Totales CONTADO
  const contadoTotalPayed = values?.payments_contado?.reduce(
    (acc, p) => acc + (Number(p.payment_amount) || 0),
    0
  );

  const contadoTotalInvoice = values?.invoices_contado?.reduce(
    (acc, f) => acc + (Number(f.invoice_amount) || 0),
    0
  );

  // Totales CRÉDITO
  const creditoTotalPayed = values?.payments_credito?.reduce(
    (acc, p) => acc + (Number(p.payment_amount) || 0),
    0
  );

  const creditoTotalInvoice = values?.invoices_credito?.reduce(
    (acc, f) => acc + (Number(f.invoice_amount) || 0),
    0
  );

  const renderBadges = (payed, invoiced, label) => {
    if (!payed && !invoiced) return null;
    const diff = payed - invoiced;

    const preposition = label === "CONTADO" ? "AL" : "A";

    return (
      <>
        {payed > 0 && (
          <span className="badge bg-success ms-2">
            PAGOS {preposition} {label}: ${formatNumberWithCommas(payed)}
          </span>
        )}
        {invoiced > 0 && (
          <span className="badge bg-success ms-2">
            FACTURADO {preposition} {label}: ${formatNumberWithCommas(invoiced)}
          </span>
        )}
        {payed > 0 &&
          invoiced > 0 &&
          (diff > 1 ? (
            <span className="badge bg-danger ms-2">
              POR FACTURAR {preposition} {label}: $
              {formatNumberWithCommas(diff)}
            </span>
          ) : diff <= 1 ? (
            <span className="badge bg-success ms-2">
              PAGOS COMPLETAMENTE FACTURADOS {preposition} {label}
            </span>
          ) : (
            <span className="badge bg-warning ms-2">
              FACTURAS EXCEDIDAS POR {preposition} {label}: $
              {formatNumberWithCommas(diff)}
            </span>
          ))}
      </>
    );
  };

  return (
    <div className="accordion" id="accordion">
      {/* Contado */}
      <div className="accordion-item border-0">
        <div className="accordion-header" id="headingOne">
          <button
            className="accordion-button bg-gray-900 text-white px-3 py-10px pointer-cursor collapsed"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#collapseOne"
          >
            <i className="fa fa-circle fa-fw text-blue me-2 fs-8px"></i> Pagos y
            Facturación de CONTADO
            {renderBadges(contadoTotalPayed, contadoTotalInvoice, "CONTADO")}
          </button>
        </div>
        <div
          id="collapseOne"
          className="accordion-collapse collapse"
          data-bs-parent="#accordion"
        >
          <div className="accordion-body bg-gray-100">
            <Row>
              <Col md="12">
                <h3>Contado</h3>
              </Col>
            </Row>
            <Row>
              {paymentTypes && (
                <>
                  <h5 className="mt-10px">
                    <i className="fa-solid fa-sack-dollar"></i> Pagos
                  </h5>
                  <p className="text-danger mt-1">
                    <strong>Importante:</strong> para generar una factura, debes
                    de guardar los cambios usando el botón al final del
                    formulario.
                  </p>

                  <TablePaymentsVaroExpress
                    //ref={tablePaymentsContadoRef}
                    paymentTypeCode="CONTADO"
                    tipoOrden="ordenVial"
                    destination_company="VaroExpress"
                    valuesKey="payments_contado"
                    disabled={disabled}
                  />
                  <h5 className="mt-10px">
                    <i className="fa-solid fa-file-invoice"></i> Facturas
                  </h5>
                  <TableInvoices
                    setPaymentTypes={setPaymentTypes}
                    paymentTypeCode="CONTADO"
                    valuesKey="invoices_contado"
                    nomenclaturaInicial="AA"
                    tipoOrden="ordenVial"
                    disabled={disabled}
                  />
                </>
              )}
            </Row>
          </div>
        </div>
      </div>

      {/* Crédito */}
      <div className="accordion-item border-0">
        <div className="accordion-header" id="headingTwo">
          <button
            className="accordion-button bg-gray-900 text-white px-3 pt-10px pb-10px pointer-cursor collapsed"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#collapseTwo"
          >
            <i className="fa fa-circle fa-fw text-indigo me-2 fs-8px"></i> Pagos
            y Facturación a CRÉDITO
            {renderBadges(creditoTotalPayed, creditoTotalInvoice, "CRÉDITO")}
          </button>
        </div>
        <div
          id="collapseTwo"
          className="accordion-collapse collapse"
          data-bs-parent="#accordion"
        >
          <div className="accordion-body bg-gray-100">
            <Row>
              <Col md="12">
                <h3>Crédito</h3>
              </Col>
            </Row>
            <Row>
              <Col md="12">
                {paymentTypes && (
                  <>
                    <h5 className="mt-10px">
                      <i className="fa-solid fa-file-invoice"></i> Facturas
                    </h5>

                    <TableInvoices
                      setPaymentTypes={setPaymentTypes}
                      paymentTypeCode="CREDITO"
                      valuesKey="invoices_credito"
                      nomenclaturaInicial="BB"
                      tipoOrden="ordenVial"
                      disabled={disabled}
                    />
                    <h5 className="mt-10px">
                      <i className="fa-solid fa-sack-dollar"></i> Pagos
                    </h5>
                    <p className="text-danger mt-1">
                      <strong>Importante:</strong> para generar una factura,
                      debes de guardar los cambios usando el botón al final del
                      formulario.
                    </p>
                    <TablePaymentsVaroExpress
                      //ref={tablePaymentsCreditoRef}
                      tipoOrden="ordenVial"
                      destination_company="VaroExpress"
                      paymentTypeCode="CREDITO"
                      valuesKey="payments_credito"
                      disabled={disabled}
                    />
                  </>
                )}
              </Col>
            </Row>
          </div>
        </div>
      </div>

      {/* Facturación SW */}
      <div className="accordion-item border-0">
        <div className="accordion-header" id="headingSW">
          <button
            className="accordion-button bg-gray-900 text-white px-3 py-10px pointer-cursor collapsed"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#collapseSW"
            aria-expanded="false"
            aria-controls="collapseSW"
          >
            <i className="fa fa-circle fa-fw text-blue me-2 fs-8px"></i>
            Facturación
            {totalFacturadoSW > 0 && (
              <span className="badge bg-primary ms-2">
                TOTAL FACTURADO DE LA ORDEN: ${formatNumberWithCommas(totalFacturadoSW)}
              </span>
            )}
          </button>
        </div>
        <div
          id="collapseSW"
          className="accordion-collapse collapse"
          aria-labelledby="headingSW"
          data-bs-parent="#accordion"
        >
          <div className="accordion-body bg-gray-100">
            <Row>
              <Col md="12">
                <h3>Facturas de la orden</h3>
              </Col>
            </Row>
            <Row>
              <Col md="12">
                <>
                  <h5 className="mt-10px">
                    <i className="fa-solid fa-file-invoice"></i> Facturas
                  </h5>
                  <DatatableStampedInvoices
                    razonSocialFacturacion={razonSocialFacturacion}
                    tipoOrden="vial"
                    refreshKey={refreshKey}
                    onTotalsChange={setTotalFacturadoSW}
                  />
                </>
              </Col>
            </Row>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AccordionPayments;
